import React from 'react';
import { useTranslation } from 'react-i18next';
import { TDR } from 'tdr-common';
import { resolveLocalizedText } from '../../../helpers/resolveLocalizedText';
import { NoticeTile } from '../../notice-cards/NoticeTile';

export type InboundLinkSectionProps = {
	section: TDR.SearchConfig.InboundLinkSection;
};

export function InboundLinkSection({ section }: InboundLinkSectionProps) {
	const { i18n } = useTranslation();
	const url = section.url?.trim();

	if (!url || !section.header) {
		return null;
	}

	return (
		<section className='px-5 pt-6 sm:px-0 sm:pt-4'>
			<NoticeTile
				icon='event'
				title={resolveLocalizedText(section.header, i18n.language)}
				subtitle={section.body ? resolveLocalizedText(section.body, i18n.language) : ''}
				href={url}
				external
				data-cy='inbound-link-card'
			/>
		</section>
	);
}
